<template>
  <div
      class="d-flex flex-grow-1 mh-0 overflow-y-auto flex-column gmb-radio-button-group"
      :id="id"
  >
    <GmbSearchField
        v-if="showSearchField"
        @search-updated="(searchString) => onSearchUpdated(searchString)"
    />

    <div
        :class="[
        'd-flex flex-grow-1 mh-0 overflow-y-auto flex-column',
        { 'mt-2': showSearchField },
      ]"
    >
      <FdScroll y>
        <b-form-radio-group
            v-model="model"
            class="d-flex flex-grow-1 mh-0 flex-column"
        >
          <slot/>
        </b-form-radio-group>
      </FdScroll>
    </div>

    <GmbRow v-if="hasNoDisplayedDomNode">
      <FdText colorWhite tag="span"
      >Aucun résultat ne correspond aux critères de recherche
      </FdText
      >
    </GmbRow>
  </div>
</template>

<script>
import {convertAsKeywords} from "@/helpers";

import FdScroll from "@/flexdesign/Scroll";
import FdText from "@/flexdesign/Text";

import GmbRow from "@/widgets/Row";
import GmbSearchField from "@/widgets/SearchField";

export default {
  name: "GmbRadioButtonGroup",

  components: {
    FdScroll,
    FdText,

    GmbRow,
    GmbSearchField,
  },

  props: {
    activatedValue: String,
    allValues: Array,
    disableSearch: Boolean,
    id: String,
    keywordObjs: Array,
  },

  data() {
    return {
      allDomNodeIds: [],
      displayedDomNodeIds: [],
    };
  },

  computed: {
    model: {
      get() {
        return this.activatedValue;
      },

      set(newActivatedValue) {
        this.$emit("activated-value-changed", newActivatedValue);
      },
    },

    hasNoDisplayedDomNode() {
      return this.keywordObjs && !this.displayedDomNodeIds.length;
    },

    hasSeveralDisplayedDomNodes() {
      return this.keywordObjs && this.displayedDomNodeIds.length >= 2;
    },

    hasSeveralValues() {
      return this.allValues && this.allValues.length >= 2;
    },

    showSearchField() {
      return this.hasSeveralValues && this.keywordObjs && !this.disableSearch
          ? true
          : false;
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
    if (this.keywordObjs) {
      for (const keywordObj of this.keywordObjs)
        this.allDomNodeIds.push(keywordObj.value);

      this.displayedDomNodeIds = this.allDomNodeIds;
    }
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    onSearchUpdated(searchString) {
      if (searchString.replace(" ", "")) {
        this.displayedDomNodeIds = [];
        for (const searchKeyword of convertAsKeywords(searchString))
          for (const keywordObj of this.keywordObjs) {
            let toBeDisplayed = false;

            for (const keywordObjKeyword of keywordObj.keywords)
              if (
                  keywordObjKeyword
                      .toLowerCase()
                      .includes(searchKeyword.toLowerCase())
              ) {
                toBeDisplayed = true;
                break;
              }

            if (toBeDisplayed) this.displayedDomNodeIds.push(keywordObj.value);
          }
      } else this.displayedDomNodeIds = this.allDomNodeIds;

      this.refreshDomNodeIdsToBeDisplayed();
    },

    refreshDomNodeIdsToBeDisplayed() {
      let isFirstDisplayedDomNode = true;
      for (const domNodeId of this.allDomNodeIds) {
        const domNode = this.id
            ? document.getElementById(this.id + "-" + domNodeId)
            : document.getElementById(domNodeId);
        const parentDomNode = domNode.parentNode;

        if (this.displayedDomNodeIds.includes(domNodeId)) {
          if (domNode.classList.contains("d-none"))
            domNode.classList.remove("d-none");
          domNode.classList.add("d-flex");

          if (isFirstDisplayedDomNode) {
            if (domNode.classList.contains("mt-2"))
              domNode.classList.remove("mt-2");
          } else domNode.classList.add("mt-2");

          isFirstDisplayedDomNode = false;
        } else {
          if (domNode.classList.contains("d-flex"))
            domNode.classList.remove("d-flex");
          domNode.classList.add("d-none");
        }
      }
    },
  },
};
</script>

<style lang="scss"></style>
